import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductDrawerMessage } from '../../../product-detail/models/product-drawer-message';
import { ProductAlertMessage } from '../../../product-detail/models/product-alert-message';

@Component({
  selector: 'app-product-card-drawer',
  templateUrl: './product-card-drawer.component.html',
  styleUrls: ['./product-card-drawer.component.scss'],
})
export class ProductCardDrawerComponent {
  @Input() drawerMessage: ProductDrawerMessage;
  @Input() warningMessage: ProductAlertMessage;

  @Output() infoIconClickEmitter: EventEmitter<void> = new EventEmitter();

  constructor() {}

  onInfoIconClick(event: Event) {
    event.stopPropagation();
    this.infoIconClickEmitter.emit();
  }
}
